import React, { Fragment, useState, useEffect, useRef } from "react";
import { VersionBanner, FRONTEND_VERSION } from "../VersionBanner";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import ApplicationLogo from "../Logos/ApplicationLogo";

import Echo from "laravel-echo";
import Pusher from "pusher-js";

import { Disclosure, Dialog, Transition } from "@headlessui/react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faBooks, faBug } from "@fortawesome/pro-regular-svg-icons";

import { faFileChartColumn, faCogs, faSearch, faMeterBolt, faAt, faBuildingCircleCheck, faCommentsQuestion, faCalendar, faBagShopping, faUser, faRobot } from "@fortawesome/pro-regular-svg-icons";

import axios from "axios";
import { getStaff, signOutUser } from "../../store/auth/authActions";
import { getTemplateCategories, getTemplates, getWhatsappTemplates } from "../../store/template/templateActions";
import AppLoader from "./AppLoader";
import { getTags } from "../../store/tag/tagActions";

import ProfilePicture from "../Auth/ProfilePicture";
import StaffOnline from "../Auth/StaffOnline";
import { getBooking, getFlaggedIds } from "../../store/booking/bookingActions";
import { getProperties } from "../../store/property/propertyActions";

import { openModal } from "../../store/modal/modalReducer";
import { faMessagePlus } from "@fortawesome/pro-solid-svg-icons";
import { getFolders } from "../../store/tag/folderActions";
import { getCollections } from "../../store/collection/collectionActions";
import { getAppointments } from "../../store/appointments/appointmentActions";
import { getManagers } from "../../store/managers/managersActions";
import { getSettings } from "../../store/settings/settingsActions";

// import { getSender } from "./Helper";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function NavBar() {
    const [totalLeasingCount, setTotalLeasingCount] = useState(0);
    const [allResidents, setAllResidents] = useState(0);
    const [allResidentsRed, setAllResidentsRed] = useState(0);
    const [allResidentsOrange, setAllResidentsOrange] = useState(0);
    const [allLoading, setAllLoading] = useState(0);
    const [allLoadingRed, setAllLoadingRed] = useState(0);
    const [allLoadingOrange, setAllLoadingOrange] = useState(0);
    const [allVacating, setAllVacating] = useState(0);
    const [allVacatingRed, setAllVacatingRed] = useState(0);
    const [allVacatingOrange, setAllVacatingOrange] = useState(0);
    const [allGeneral, setAllGeneral] = useState(0);
    const [allGeneralRed, setAllGeneralRed] = useState(0);
    // Archived tags will be loaded on demand
    const [allLeasingRed, setAllLeasingRed] = useState(0);
    const [totalCollections, setTotalCollections] = useState(0);
    const [totalBrokers, setTotalBrokers] = useState(0);
    const [totalBrokersRed, setTotalBrokersRed] = useState(0);
    const [totalGeneralCount, setTotalGeneralCount] = useState(0);
    const [totalResidentsCount, setTotalResidentsCount] = useState(0);
    const [totalLoadingCount, setTotalLoadingCount] = useState(0);
    const [totalVacatingCount, setTotalVacatingCount] = useState(0);
    const [totalArchivedCount, setTotalArchivedCount] = useState(0);
    const [orphanedLeasing, setOrphanedLeasing] = useState(0);
    const [orphanedRedLeasing, setOrphanedRedLeasing] = useState(0);
    const [orphanedResidents, setOrphanedResidents] = useState(0);
    const [orphanedRedResidents, setOrphanedRedResidents] = useState(0);
    const [orphanedLoading, setOrphanedLoading] = useState(0);
    const [orphanedRedLoading, setOrphanedRedLoading] = useState(0);
    const [orphanedVacating, setOrphanedVacating] = useState(0);
    const [orphanedRedVacating, setOrphanedRedVacating] = useState(0);
    const [orphanedGeneral, setOrphanedGeneral] = useState(0);
    const [orphanedRedGeneral, setOrphanedRedGeneral] = useState(0);
    const [orphanedArchived, setOrphanedArchived] = useState(0);
    const [orphanedRedArchived, setOrphanedRedArchived] = useState(0);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [totalMention, setTotalMention] = useState("0 | 0");
    const [loading, setLoading] = useState(false);
    const [mbBalance, setMbBalance] = useState("");
    const [menu_nav, setMenuNav] = useState([
        {
            name: "All",
            icon: "home",
            href: "/booking/all",
            count: 0,
            red: "",
        },
    ]);
    const [tagsList, setTagsList] = useState([]);
    const [tagsList23, setTagsList23] = useState([]);
    const [archivedTagsList, setArchivedTagsList] = useState([]);
    const [collectionsList, setCollectionsList] = useState([]);
    const [loadingTagsList, setLoadingTagsList] = useState([]);
    const [vacatingTagsList, setVacatingTagsList] = useState([]);

    // Helper function to calculate contrast color for text based on background color
    const getContrastColor = (hexColor) => {
        // Default to white text if no color is provided
        if (!hexColor || typeof hexColor !== "string" || !hexColor.startsWith("#")) {
            return "#FFFFFF"; // Default to white text on unknown background
        }

        try {
            // If the color is light, return dark color, and vice versa
            const r = parseInt(hexColor.substr(1, 2), 16);
            const g = parseInt(hexColor.substr(3, 2), 16);
            const b = parseInt(hexColor.substr(5, 2), 16);
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 128 ? "#000000" : "#FFFFFF";
        } catch (error) {
            console.error("Error calculating contrast color:", error);
            return "#FFFFFF"; // Default to white text on error
        }
    };

    // ArchivedSection component to handle archived tags loading
    const ArchivedSection = () => {
        // Determine route first so we can safely use it in initial state/props
        const location = useLocation();
        const pathname = location.pathname;
        const searchParams = new URLSearchParams(location.search);
        const dispatch = useDispatch();
        const isArchivedRoute = pathname.startsWith("/booking/archived");

        const [archivedTags, setArchivedTags] = useState([]);
        const [untaggedCount, setUntaggedCount] = useState(0);
        const hasLoaded = useRef(false);
        const [isLoading, setIsLoading] = useState(false);

        const loadArchivedTags = async () => {
            if (hasLoaded.current) {
                return;
            }

            setIsLoading(true);
            try {
                const response = await axios.get("archived-tags");
                // Support new response shape { tags: [...], untagged: N } with backward compatibility
                const payload = response.data;
                let tagsArray = [];
                if (Array.isArray(payload)) {
                    tagsArray = payload;
                    setUntaggedCount(0);
                } else if (Array.isArray(payload?.tags)) {
                    tagsArray = payload.tags;
                    setUntaggedCount(payload?.untagged ?? 0);
                } else if (payload?.tags && typeof payload.tags === "object") {
                    // Some backends may return an object keyed by id; coerce to array
                    tagsArray = Object.values(payload.tags);
                    setUntaggedCount(payload?.untagged ?? 0);
                } else {
                    tagsArray = [];
                    setUntaggedCount(0);
                }

                // Final normalization to ensure an array of objects
                if (!Array.isArray(tagsArray)) tagsArray = [];
                setArchivedTags(tagsArray);
                hasLoaded.current = true;
            } catch (error) {
                console.error("Error loading archived tags:", error);
            } finally {
                setIsLoading(false);
            }
        };

        // Effect: if user navigates directly to an archived route, load once
        useEffect(() => {
            if (isArchivedRoute && !hasLoaded.current) {
                loadArchivedTags();
            }
        }, [isArchivedRoute]);

        return (
            <Disclosure as="div" className="space-y-1" defaultOpen={isArchivedRoute}>
                {({ open }) => (
                    <>
                        <Disclosure.Button
                            id="archived-section-button"
                            onClick={() => {
                                // Only load when opening and not yet loaded
                                const willOpen = !open;
                                if (willOpen && !hasLoaded.current) {
                                    loadArchivedTags();
                                }
                            }}
                            className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none"
                        >
                            <svg
                                className={classNames(
                                    open ? "rotate-90" : "",
                                    "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                )}
                                viewBox="0 0 20 20"
                                aria-hidden="true"
                            >
                                <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                            </svg>
                            <span className="flex-1 font-light text-xs pr-4">ARCHIVED</span>
                        </Disclosure.Button>
                        <Transition
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Disclosure.Panel className="space-y-1">
                                {isLoading ? (
                                    <div className="px-4 py-2 text-xs text-white">Loading archived tags...</div>
                                ) : (
                                    <>
                                        <Link
                                            to="/booking/archived"
                                            className={classNames(
                                                searchParams.get("tag") === "untagged" ? "bg-white text-dark_background" : "hover:bg-white text-white hover:text-dark_background",
                                                "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-light transition ease-linear delay-50",
                                            )}
                                        >
                                            <span className="truncate">Untagged</span>
                                            <span className="ml-auto text-green-400 text-xs">{untaggedCount}</span>
                                        </Link>
                                        {(Array.isArray(archivedTags) ? archivedTags : []).map((tag) => (
                                            <Link
                                                key={tag.id}
                                                to={`/booking/archived?tag=${tag.id}`}
                                                className={classNames(
                                                    searchParams.get("tag") === String(tag.id) ? "bg-white text-dark_background" : "hover:bg-white text-white hover:text-dark_background",
                                                    "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-light transition ease-linear delay-50",
                                                )}
                                            >
                                                <span className="truncate flex-1">{tag.name}</span>
                                                <span className="text-green-400 text-xs ml-2">{tag.count}</span>
                                            </Link>
                                        ))}
                                    </>
                                )}
                            </Disclosure.Panel>
                        </Transition>
                    </>
                )}
            </Disclosure>
        );
    };
    let location = useLocation();
    const dispatch = useDispatch();

    const { staff, current_staff, login_method } = useSelector((state) => state.auth);
    const { settings } = useSelector((state) => state.settings);

    var url_string = window.location.href;
    var url = new URL(url_string);
    var tag_id = url.searchParams.get("tag");
    var collection_tag = url.searchParams.get("collection_tag");


    if (!current_staff?.id) {
        signout();
    }

    async function signout() {
        setLoading(true);

        try {
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}logout`,
                headers: {
                    Authorization: `Bearer ${current_staff?.token}`,
                },
            });
        } catch (error) {
            console.log(error);
        } finally {
            await dispatch(signOutUser());
            window.location.replace("/login");
        }
    }

    useEffect(() => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}balance`,
        })
            .then((response) => {
                if (!response.data.amount) {
                    setMbBalance("Not Messagebird");
                } else {
                    setMbBalance(response.data.amount);
                }
            })
            .catch((error) => {
                if (error.response?.status === 401) {
                    signout();
                }
            });
    }, []);

    // Echo singleton + debounce guards
    const echoRef = useRef(null);
    const debounceRef = useRef({ tags: 0, channels: 0 });
    const DEBOUNCE_MS = 300;

    useEffect(() => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;

        if (!echoRef.current) {
            if (process.env.REACT_APP_REVERB_APP_ID) {
                echoRef.current = new Echo({
                    broadcaster: "reverb",
                    key: process.env.REACT_APP_REVERB_APP_KEY,
                    wsHost: process.env.REACT_APP_REVERB_URL,
                    wssHost: process.env.REACT_APP_REVERB_URL,
                    wsPort: process.env.REACT_APP_REVERB_PORT,
                    wssPort: process.env.REACT_APP_REVERB_PORT,
                    disableStats: true,
                    encrypted: process.env.REACT_APP_REVERB_SCHEME === "https",
                    forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
                    enableLogging: true,
                });
            } else {
                echoRef.current = new Echo({
                    broadcaster: "pusher",
                    key: process.env.REACT_APP_MIX_ABLY_PUBLIC_KEY,
                    wsHost: process.env.REACT_APP_MIX_ABLY_URL,
                    wssHost: process.env.REACT_APP_MIX_ABLY_URL,
                    wsPort: process.env.REACT_APP_MIX_ABLY_PORT,
                    wssPort: process.env.REACT_APP_MIX_ABLY_PORT,
                    disableStats: true,
                    encrypted: false,
                    enabledTransports: ["ws", "wss"],
                    forceTLS: false,
                    enableLogging: true,
                });
            }
        }

        const echo = echoRef.current;

        echo.channel("channels.list")
            .subscribed(() => {})
            .listen(".channels.list", (data) => {
                // Debounce to avoid hammering state during floods
                const now = Date.now();
                if (now - debounceRef.current.channels < DEBOUNCE_MS) return;
                debounceRef.current.channels = now;

                const array = [];

                let totalL = 0;
                let totalResidents = 0;
                let totalLoading = 0;
                let totalVacating = 0;
                let totalGeneral = 0;
                let totalArchived = 0;
                let orphanedDeclined = 0;
                let orphanedDeclinedRed = 0;
                let orphanedDeclinedOrange = 0;
                let orphanedDeclinedGreen = 0;

                // console.log("channels.list data received:", data);

                // First pass to get orphaned declined counts
                data.forEach((item) => {
                    if (item.name === "Orphaned Bookings") {
                        orphanedDeclined = item.declined || 0;
                        orphanedDeclinedRed = item.declinedRed || 0;
                        orphanedDeclinedOrange = item.declinedOrange || 0;
                        orphanedDeclinedGreen = item.declinedGreen || 0;
                    }
                });

                data.forEach((item) => {
                    if (item.name === "Declined" || item.name === "Cancelled") {
                        item.count = (item.declined || 0) + orphanedDeclined;
                        item.red = (item.declinedRed || 0) + orphanedDeclinedRed;
                        item.countOrange = (item.declinedOrange || 0) + orphanedDeclinedOrange;
                        item.countGreen = (item.declinedGreen || 0) + orphanedDeclinedGreen;
                        // console.log(item);
                    }

                    if (item.name === "Orphaned Bookings") {
                        totalResidents = item.residents;
                        totalLoading = item.loading;
                        totalVacating = item.vacating;
                        totalGeneral = item.general;
                        totalArchived = item.archived || 0;

                        setAllResidentsRed(item.residentsRed || 0);
                        setAllResidentsOrange(item.residentsOrange || 0);
                        setAllLoadingRed(item.loadingRed || 0);
                        setAllLoadingOrange(item.loadingOrange || 0);
                        setAllVacatingRed(item.vacatingRed || 0);
                        setAllVacatingOrange(item.vacatingOrange || 0);
                        setAllGeneralRed(item.generalRed || 0);
                        // Archived counts are now loaded on demand
                        setAllLeasingRed(item.leasingRed || 0);

                        setOrphanedLeasing(item.orphanedLeasing || 0);
                        setOrphanedRedLeasing(item.orphanedRedLeasing || 0);
                        setOrphanedResidents(item.orphanedResidents || 0);
                        setOrphanedRedResidents(item.orphanedRedResidents || 0);
                        setOrphanedLoading(item.orphanedLoading || 0);
                        setOrphanedRedLoading(item.orphanedRedLoading || 0);
                        setOrphanedVacating(item.orphanedVacating || 0);
                        setOrphanedRedVacating(item.orphanedRedVacating || 0);
                        setOrphanedGeneral(item.orphanedGeneral || 0);
                        setOrphanedRedGeneral(item.orphanedRedGeneral || 0);
                        // Orphaned archived counts are no longer used

                        setTotalResidentsCount(item.totalResidents || 0);
                        setTotalGeneralCount(item.totalGeneral || 0);
                        setTotalLoadingCount(item.totalLoading || 0);
                        setTotalVacatingCount(item.totalVacating || 0);

                        // console.log("Processing Orphaned Bookings item:", {
                        //     // Archived tags are now loaded on demand
                        //     currentArchivedTagsList: archivedTagsList,
                        // });

                        // console.log("Archived counts:", {
                        //     totalArchived: item.archived,
                        //     // Archived tags are loaded on demand
                        //     archivedRed: item.archivedRed,
                        //     archivedOrange: item.archivedOrange,
                        //     archivedTagsList: archivedTagsList.map((t) => ({ id: t.id, name: t.name, count: t.count })),
                        // });

                        setTotalLeasingCount(item.totalLeasing || 0);

                        setAllResidents(item.residents || 0);
                        setAllLoading(item.loading || 0);
                        setAllVacating(item.vacating || 0);
                        setAllGeneral(item.general || 0);
                    }

                    array.push(item);

                    if (item.name !== "Orphaned Bookings" && item.name !== "Declined" && item.name !== "Cancelled") {
                        totalL += item.count ?? 0;
                    }
                });

                setTotalLeasingCount(totalL);
                setMenuNav(array);
            });

        echo.channel("tags.list")
            .subscribed(() => {})
            .listen(".tags.list", (data) => {
                // Debounce to avoid hammering state during floods
                const now = Date.now();
                if (now - debounceRef.current.tags < DEBOUNCE_MS) return;
                debounceRef.current.tags = now;

                const array = [];
                Object.keys(data).forEach((key) => {
                    if (key > -1) {
                        array.push(data[key]);
                    }
                });

                // console.log("All tags data:", array);

                let residentsTagsList = array.filter((item) => item.parent_folder === "Residents").sort((a, b) => (a.sort_order > b.sort_order ? -1 : 1));
                let generalTagsList = array.filter((item) => item.parent_folder === "General").sort((a, b) => (a.sort_order > b.sort_order ? -1 : 1));
                let loadingTagsList = array.filter((item) => item.parent_folder === "Loading").sort((a, b) => (a.sort_order > b.sort_order ? -1 : 1));
                let vacatingTagsList = array.filter((item) => item.parent_folder === "Vacating").sort((a, b) => (a.sort_order > b.sort_order ? -1 : 1));

                setTagsList(residentsTagsList);
                setTagsList23(generalTagsList);
                setLoadingTagsList(loadingTagsList);
                setVacatingTagsList(vacatingTagsList);
            });

        if (!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") {
            echo.channel("collections.list")
                .subscribed(() => {})
                .listen(".collections.list", (data) => {
                    const array = [];
                    Object.keys(data).forEach((key) => {
                        if (key > -1) {
                            array.push(data[key]);
                        }
                    });

                    setTotalCollections(data[0].countAll + data[0].ex);
                    let arrayFilter = array.sort((a, b) => (a.sort_order > b.sort_order ? 1 : -1));
                    setCollectionsList(arrayFilter);
                });
        }

        if (!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") {
            if (settings && settings.brokers === 1) {
                echo.channel("brokers.list")
                    .subscribed(() => {})
                    .listen(".brokers.list", (data) => {
                        setTotalBrokers(data[0].count);
                        setTotalBrokersRed(data[0].red);
                    });
            }
        }

        echo.channel(`mentionList.${current_staff?.id}`)
            .subscribed(() => {})
            .listen("MentionEvent", (data) => {
                const opened = data[0][0].count;
                const closed = data[1][0].count;
                const total = opened + closed;
                setTotalMention(opened + " | " + total);
            });

        if (current_staff) {
            dispatch(getStaff());
            dispatch(getProperties());
            dispatch(getTags());
            dispatch(getFolders());
            dispatch(getCollections());
            dispatch(getAppointments());
            dispatch(getManagers());
            dispatch(getSettings());
            dispatch(getFlaggedIds());
            dispatch(getBooking());
            dispatch(getTemplates());
            dispatch(getWhatsappTemplates());
            dispatch(getTemplateCategories());

            setLoading(false);
        }

        return () => {
            if (echoRef.current) {
                echoRef.current.disconnect();
                echoRef.current = null;
            }
        };
    }, [dataLoaded]);

    const navigationYou = [
        {
            name: "Mentions",
            icon: faAt,
            href: "/booking/mentions/0",
            count: totalMention || "0 | 0",
        },
    ];

    let settings_navigation = [];

    if (!current_staff?.building_manager) {
        if (!current_staff?.is_plumber && !current_staff?.is_electrician) {
            if (!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") {
                settings_navigation.push({ name: "Orders", icon: faBagShopping, href: "/orders/landing" });
            }

            settings_navigation.push({ name: "Reports", icon: faFileChartColumn, href: "/reports/landing" });
            settings_navigation.push({ name: "Properties", icon: faBuildingCircleCheck, href: "/properties/step1" });
            if (["QP", "QL", "UC"].includes(process.env.REACT_APP_COLOUR) && current_staff?.status === "Admin") {
                settings_navigation.push({ name: "Settings", icon: faCogs, href: "/settings" });
                settings_navigation.push({ name: "Settings New", icon: faCogs, href: "/settings_new" });
                settings_navigation.push({ name: "Users", icon: faUser, href: "/settings_users/0" });
                settings_navigation.push({ name: "Live Dashboard", icon: faRobot, href: "/reports/live_dashboard" });
            }

            if (process.env.REACT_APP_COLOUR === "QL") {
                settings_navigation.push({ name: "Meter Readings", icon: faMeterBolt, href: "/meterreadings" });
            }
        }

        settings_navigation.push({ name: "Calendar", icon: faCalendar, href: "/calendar/landing" });
    } else {
        if (current_staff.create_order == 1) {
            settings_navigation.push({ name: "Orders", icon: faBagShopping, href: "/orders/landing" });
        }
        settings_navigation.push({ name: "Properties", icon: faBuildingCircleCheck, href: "/properties/step1" });
        settings_navigation.push({ name: "Calendar", icon: faCalendar, href: "/calendar/landing" });
        settings_navigation.push({ name: "Settings", icon: faCogs, href: "/settings" });
    }

    if (loading === true) return <AppLoader />;

    return (
        <>
            <Transition.Root show={sidebarOpen} as={Fragment}>
                <Dialog as="div" className="fixed inset-0 flex z-40 md:hidden" onClose={setSidebarOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
                    </Transition.Child>
                    <Transition.Child
                        as={Fragment}
                        enter="transition ease-in-out duration-300 transform"
                        enterFrom="-translate-x-full"
                        enterTo="translate-x-0"
                        leave="transition ease-in-out duration-300 transform"
                        leaveFrom="translate-x-0"
                        leaveTo="-translate-x-full"
                    >
                        <div className="relative flex-1 flex flex-col max-w-xs w-full bg-black">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-in-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in-out duration-300"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="absolute top-0 right-0 -mr-12 pt-2">
                                    <button
                                        type="button"
                                        className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                        onClick={() => setSidebarOpen(false)}
                                    >
                                        <span className="sr-only">Close sidebar</span>
                                        <FontAwesomeIcon className="h-6 w-6 text-white" aria-hidden="true" icon={faTimes} />
                                    </button>
                                </div>
                            </Transition.Child>
                            <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                                <div className="flex-shrink-0 flex flex-col items-center px-4 gap-2">
                                    ?
                                    <VersionBanner variant="inline" />
                                    <Link to="/">
                                        {process.env.REACT_APP_COLOUR === "UC" ? <ApplicationLogo className="h-10 w-auto text-white" /> : <ApplicationLogo className="h-12 w-auto text-white" square />}
                                    </Link>
                                </div>
                                <nav className="mt-5 px-2 space-y-1">
                                    {current_staff?.hideSearch != 1 && (
                                        <div className="flex text-white">
                                            <button
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            modal_type: "ModalSearch",
                                                        }),
                                                    )
                                                }
                                                type="button"
                                                className="hover:bg-white hover:rounded-3xl text-white group flex items-center pr-3 py-2 text-sm font-medium hover:text-dark_background"
                                            >
                                                <FontAwesomeIcon className="mr-3 w-6 flex-shrink-0 text-primary" aria-hidden="true" icon={faSearch} />
                                                <span className="flex-1 font-light">Search</span>
                                            </button>
                                        </div>
                                    )}

                                    {menu_nav.map((item) => (
                                        <a
                                            key={"menunav_" + item.name}
                                            href={item.href}
                                            className={classNames(
                                                location.pathname === item.href ? "bg-primary_hover" : "hover:bg-primary_hover hover:text-white",
                                                "group flex items-center px-2 py-2 text-sm font-medium rounded-md",
                                            )}
                                        >
                                            <span className="flex-1 text-gray-200">{item.name}</span>
                                            {item.count ? (
                                                <>
                                                    <span
                                                        className={classNames(
                                                            location.pathname === item.href ? "bg-black" : "bg-primary hover:bg-black",
                                                            "ml-3 inline-block py-1 px-3 text-white text-xs font-medium rounded-full",
                                                        )}
                                                    >
                                                        {item.count}
                                                    </span>
                                                </>
                                            ) : null}
                                        </a>
                                    ))}
                                    <hr />
                                    {settings_navigation.map((item) => (
                                        <a
                                            key={"sett2nav_" + item.name}
                                            href={item.href}
                                            className={classNames(
                                                location.pathname === item.href ? "bg-primary_hover" : "hover:bg-primary_hover hover:text-white",
                                                "group flex items-center px-2 py-2 text-sm font-medium rounded-md",
                                            )}
                                        >
                                            <span className="flex-1 text-gray-200">{item.name}</span>
                                        </a>
                                    ))}
                                    <a
                                        className={classNames("hover:bg-primary_hover hover:text-white", "group flex items-center px-2 py-2 text-sm font-medium rounded-md")}
                                        href="https://forms.clickup.com/9012594561/f/8ck2hw1-1412/ZXA7LJUYVDE7HBDMS3"
                                        target="_blank"
                                    >
                                        Log a Ticket
                                    </a>
                                </nav>
                            </div>
                            <div className="flex-shrink-0 flex bg-black p-4">
                                <div className="flex items-center">
                                    <ProfilePicture id={current_staff?.id} />
                                    <div className="ml-1">
                                        <p className="text-sm text-divider font-light uppercase">
                                            {current_staff?.name + " " + current_staff?.surname} {current_staff?.status === "Admin" && " (" + current_staff?.status + ")"}
                                        </p>
                                        {login_method && (
                                            <p className="text-[10px] font-semibold uppercase tracking-wide">
                                                <span className={login_method === "sso" ? "text-green-400" : "text-amber-400"}>
                                                    {login_method === "sso" ? "● Signed in via SSO" : "● Signed in via password"}
                                                </span>
                                            </p>
                                        )}
                                        <button className="text-xs  text-divider font-light group-hover:text-gray-200 uppercase" onClick={() => signout()}>
                                            Sign Out
                                        </button>

                                        <p className="text-sm text-divider font-light uppercase">V {FRONTEND_VERSION}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition.Child>
                    <div className="flex-shrink-0 w-14">{/* Force sidebar to shrink to fit close icon */}</div>
                </Dialog>
            </Transition.Root>

            <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
                <div className="flex-1 flex flex-col pl-6 rounded-3xl min-h-0 bg-dark_background">
                    <div className="flex-1 flex flex-col pt-2 pb-4 overflow-y-auto">
                        <div className="flex flex-col items-center justify-center gap-2 py-4 pr-4">
                            <VersionBanner variant="inline" />
                            {process.env.REACT_APP_COLOUR === "UC" ? (
                                <ApplicationLogo className="h-14 w-auto text-white" />
                            ) : process.env.REACT_APP_COLOUR === "QL" ? (
                                <ApplicationLogo className="h-24 w-auto text-white" square color="white" />
                            ) : (
                                <ApplicationLogo className="h-12 w-auto text-white" />
                            )}
                        </div>

                        <nav className="mt-5 flex-1 space-y-1">
                            {current_staff?.status === "Admin" && mbBalance != "Not Messagebird" ? (
                                <>
                                    {mbBalance > 0 ? (
                                        <p className="text-white">
                                            Credits: <span className="text-green-400">$ {mbBalance}</span>
                                        </p>
                                    ) : (
                                        <p className="text-white">
                                            Credits: <span className="text-red-400">$ {mbBalance}</span>
                                        </p>
                                    )}
                                    <br />
                                </>
                            ) : (
                                ""
                            )}

                            {current_staff?.hideSearch != 1 && (
                                <div className="flex text-white">
                                    <button
                                        onClick={() =>
                                            dispatch(
                                                openModal({
                                                    modal_type: "ModalSearch",
                                                }),
                                            )
                                        }
                                        type="button"
                                        className="hover:bg-white hover:rounded-3xl text-white group flex items-center pr-3 py-2 text-sm font-medium hover:text-dark_background"
                                    >
                                        <FontAwesomeIcon className="mr-3 w-6 flex-shrink-0 text-primary" aria-hidden="true" icon={faSearch} />
                                        <span className="flex-1 font-light">Search</span>
                                    </button>
                                </div>
                            )}

                            <div className="text-white">
                                {navigationYou.map((item) => (
                                    <Link
                                        key={"menuyounav_" + item.name}
                                        to={item.href}
                                        className={classNames(
                                            location.pathname === item.href ? "bg-white text-dark_background" : "hover:bg-white  text-white",
                                            "group flex items-center rounded-l-3xl pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background ",
                                        )}
                                    >
                                        <FontAwesomeIcon className="mr-3 w-6 flex-shrink-0 text-primary" aria-hidden="true" icon={item.icon} />
                                        <span className="flex-1 font-light">{item.name}</span>
                                        {totalMention ? <span className="ml-3 inline-block py-1 px-3 text-xs">{totalMention}</span> : null}
                                    </Link>
                                ))}
                            </div>

                            <div className="text-white">
                                <a
                                    href="/admin/resources"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={classNames(
                                        "hover:bg-white  text-white",
                                        "group flex items-center rounded-l-3xl pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                    )}
                                >
                                    <FontAwesomeIcon className="mr-3 w-6 flex-shrink-0 text-primary" aria-hidden="true" icon={faBooks} />
                                    <span className="flex-1 font-light">Resources</span>
                                </a>
                            </div>

                            {current_staff?.restrict_views === 0 && current_staff?.hideLeasing == 0 ? (
                                <Disclosure as="div" className="space-y-1">
                                    {({ open }) => (
                                        <>
                                            <Disclosure.Button className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none">
                                                <svg
                                                    className={classNames(
                                                        open ? "rotate-90" : "",
                                                        "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                                    )}
                                                    viewBox="0 0 20 20"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                                </svg>
                                                <span className="flex-1 font-light text-xs pr-4">
                                                    {process.env.REACT_APP_HIDE_CHAT_TABS && process.env.REACT_APP_HIDE_CHAT_TABS == "true" ? "LEADS" : "LEASING"}
                                                </span>
                                                <span className="ml-3 inline-block px-3 text-xs">{totalLeasingCount}</span>
                                            </Disclosure.Button>
                                            <Transition
                                                enter="transition duration-120 ease-out"
                                                enterFrom="transform scale-95 opacity-0"
                                                enterTo="transform scale-100 opacity-100"
                                                leave="transition duration-85 ease-out"
                                                leaveFrom="transform scale-100 opacity-100"
                                                leaveTo="transform scale-95 opacity-0"
                                            >
                                                <Disclosure.Panel className="space-y-1">
                                                    {menu_nav &&
                                                        menu_nav.length > 0 &&
                                                        menu_nav.map((item) => (
                                                            <Link
                                                                key={"menunav3_" + item.name}
                                                                to={item.href}
                                                                className={classNames(
                                                                    location.pathname === item.href ? "bg-white text-dark_background" : "hover:bg-white  text-white",
                                                                    "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background ",
                                                                )}
                                                            >
                                                                <span className="flex-1 font-light">{item.name}</span>

                                                                {item.red && item.red > 0 ? <span className="ml-3 inline-block py-1 pl-3 text-red-400 text-xs">{item.red} | &nbsp; </span> : null}
                                                                {item.countOrange && item.countOrange > 0 ? (
                                                                    <span className="inline-block py-1 text-xs text-yellow-400">{item.countOrange} | &nbsp; </span>
                                                                ) : null}
                                                                {item.count && item.count > 0 ? <span className="inline-block py-1 text-xs text-green-400">{item.count} &nbsp; </span> : null}
                                                            </Link>
                                                        ))}
                                                </Disclosure.Panel>
                                            </Transition>
                                        </>
                                    )}
                                </Disclosure>
                            ) : (
                                ""
                            )}

                            {current_staff?.hideResidents != 1 &&
                                (window.location.hostname === "apply.qliving.co.za" || window.location.hostname === "wh-romi-staging.whitehart.co.za" || window.location.hostname === "localhost") && (
                                    <>
                                        <Disclosure as="div" className="space-y-1">
                                            {({ open }) => (
                                                <>
                                                    <Disclosure.Button className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none">
                                                        <svg
                                                            className={classNames(
                                                                open ? "rotate-90" : "",
                                                                "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                                            )}
                                                            viewBox="0 0 20 20"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                                        </svg>
                                                        <span className="flex-1 font-light text-xs pr-4">LOADING</span>
                                                        {current_staff?.restrict_views === 0 ? <span className="ml-3 inline-block px-3 text-xs">{totalLoadingCount}</span> : ""}
                                                    </Disclosure.Button>
                                                    <Transition
                                                        enter="transition duration-100 ease-out"
                                                        enterFrom="transform scale-95 opacity-0"
                                                        enterTo="transform scale-100 opacity-100"
                                                        leave="transition duration-75 ease-out"
                                                        leaveFrom="transform scale-100 opacity-100"
                                                        leaveTo="transform scale-95 opacity-0"
                                                    >
                                                        <Disclosure.Panel>
                                                            {current_staff?.restrict_views === 0 ? (
                                                                <Link
                                                                    key="All Loading"
                                                                    to="/booking/loading"
                                                                    className={classNames(
                                                                        location.pathname === "/booking/loading" && !tag_id ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                                        "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background ",
                                                                    )}
                                                                >
                                                                    <span className="flex-1 font-light">All Loading</span>
                                                                    {allLoadingRed ? <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{allLoadingRed} | &nbsp; </span> : null}
                                                                    {allLoadingOrange > 0 ? <span className="inline-block py-1 text-xs text-yellow-400">{allLoadingOrange} | &nbsp; </span> : null}
                                                                    {allLoading ? <span className="inline-block py-1 text-xs text-green-400 font-medium">{allLoading}</span> : null}
                                                                </Link>
                                                            ) : (
                                                                ""
                                                            )}

                                                            {loadingTagsList?.length > 0 &&
                                                                loadingTagsList.map((tag) => (
                                                                    <React.Fragment key={`tag_${tag.id}`}>
                                                                        {current_staff?.restrict_views === 0 || (current_staff?.restrict_views === 1 && tag.id === 21) ? (
                                                                            tag.super_only == 0 ||
                                                                            (tag.super_only == 1 &&
                                                                                (current_staff.email == "roger@whitehart.co.za" ||
                                                                                    current_staff.email == "rowan@qholdings.co.za" ||
                                                                                    current_staff.email == "resileads@qholdings.co.za")) ? (
                                                                                <Link
                                                                                    to={"/booking/loading?tag=" + tag.id}
                                                                                    key={"loading_tag_" + tag.id}
                                                                                    className={classNames(
                                                                                        parseInt(tag_id) === tag.id ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                                                        "group flex rounded-l-3xl items-center pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                                                    )}
                                                                                >
                                                                                    <span className="flex-1 font-light">{tag.name}</span>
                                                                                    {tag.red ? (
                                                                                        <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{tag.red} | &nbsp; </span>
                                                                                    ) : null}
                                                                                    {tag.countOrange && tag.countOrange > 0 ? (
                                                                                        <span className="inline-block py-1 text-xs text-yellow-400">{tag.countOrange} | &nbsp; </span>
                                                                                    ) : null}
                                                                                    {tag.count ? <span className="inline-block py-1 text-xs text-green-400 font-medium">{tag.count}</span> : null}
                                                                                </Link>
                                                                            ) : (
                                                                                ""
                                                                            )
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </React.Fragment>
                                                                ))}

                                                            <Link
                                                                to="/booking/loading?tag=orphaned"
                                                                className={classNames(
                                                                    location.pathname === "/booking/loading?tag=orphaned" ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                                    "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                                )}
                                                            >
                                                                <span className="flex-1 font-light">Unlinked</span>
                                                                {orphanedRedLoading > 0 && <span className="ml-3 inline-block py-1 text-xs text-red-400">{orphanedRedLoading} | &nbsp; </span>}
                                                                {orphanedLoading > 0 && <span className="inline-block py-1 text-xs text-green-400">{orphanedLoading}</span>}
                                                            </Link>
                                                        </Disclosure.Panel>
                                                    </Transition>
                                                </>
                                            )}
                                        </Disclosure>
                                    </>
                                )}

                            {/* Tag Section */}
                            {current_staff?.hideResidents != 1 && (
                                <>
                                    <Disclosure as="div" className="space-y-1">
                                        {({ open }) => (
                                            <>
                                                <Disclosure.Button className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none">
                                                    <svg
                                                        className={classNames(
                                                            open ? "rotate-90" : "",
                                                            "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                                        )}
                                                        viewBox="0 0 20 20"
                                                        aria-hidden="true"
                                                    >
                                                        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                                    </svg>
                                                    <span className="flex-1 font-light text-xs pr-4">
                                                        {process.env.REACT_APP_HIDE_CHAT_TABS && process.env.REACT_APP_HIDE_CHAT_TABS == "true" ? "SALES" : "MANAGEMENT"}
                                                    </span>
                                                    {current_staff?.restrict_views === 0 ? <span className="ml-3 inline-block px-3 text-xs">{totalResidentsCount}</span> : ""}
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel>
                                                        {/* allResidents */}
                                                        {current_staff?.restrict_views === 0 ? (
                                                            <Link
                                                                key="All Residents"
                                                                to="/booking/residents"
                                                                className={classNames(
                                                                    location.pathname === "/booking/residents" ? "bg-white text-dark_background" : "hover:bg-white  text-white",
                                                                    "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background ",
                                                                )}
                                                            >
                                                                <span className="flex-1 font-light">
                                                                    {process.env.REACT_APP_HIDE_CHAT_TABS && process.env.REACT_APP_HIDE_CHAT_TABS == "true" ? "All" : "All Residents"}
                                                                </span>
                                                                {allResidentsRed > 0 ? <span className="ml-3 inline-block py-1 pl-3 text-red-400 text-xs">{allResidentsRed} | &nbsp; </span> : null}
                                                                {allResidentsOrange > 0 ? <span className="inline-block py-1 text-xs text-yellow-400">{allResidentsOrange} | &nbsp; </span> : null}
                                                                {allResidents ? <span className="inline-block py-1 text-xs text-green-400">{allResidents} &nbsp; </span> : null}
                                                            </Link>
                                                        ) : (
                                                            ""
                                                        )}

                                                        {/* tag.id === 4 */}
                                                        {tagsList?.length > 0 &&
                                                            tagsList.map((tag) => (
                                                                <React.Fragment key={`tag_${tag.id}`}>
                                                                    {current_staff?.restrict_views === 0 || (current_staff?.restrict_views === 1 && tag.id === 21) ? (
                                                                        tag.super_only == 0 ||
                                                                        (tag.super_only == 1 &&
                                                                            (current_staff.email == "roger@whitehart.co.za" ||
                                                                                current_staff.email == "rowan@qholdings.co.za" ||
                                                                                current_staff.email == "resileads@qholdings.co.za")) ? (
                                                                            <Link
                                                                                to={"/booking/management?tag=" + tag.id}
                                                                                key={"tag_" + tag.id}
                                                                                className={classNames(
                                                                                    parseInt(tag_id) === tag.id ? "bg-white  text-dark_background" : "hover:bg-white text-white",
                                                                                    "group flex rounded-l-3xl items-center pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                                                )}
                                                                            >
                                                                                <span className="flex-1 font-light">{tag.name}</span>
                                                                                {tag.red ? <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{tag.red} | &nbsp; </span> : null}
                                                                                {tag.countOrange && tag.countOrange > 0 ? (
                                                                                    <span className="inline-block py-1 text-xs text-yellow-400">{tag.countOrange} | &nbsp; </span>
                                                                                ) : null}
                                                                                {tag.count ? <span className="inline-block py-1 text-xs text-green-400 font-medium">{tag.count}</span> : null}
                                                                            </Link>
                                                                        ) : (
                                                                            ""
                                                                        )
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </React.Fragment>
                                                            ))}

                                                        <Link
                                                            to="/booking/management?tag=orphaned"
                                                            className={classNames(
                                                                location.pathname === "/booking/management?tag=orphaned" ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                                "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                            )}
                                                        >
                                                            <span className="flex-1 font-light">Unlinked</span>
                                                            {orphanedRedResidents > 0 && <span className="ml-3 inline-block py-1 text-xs text-red-400">{orphanedRedResidents} | &nbsp; </span>}
                                                            {orphanedResidents > 0 && <span className="inline-block py-1 text-xs text-green-400">{orphanedResidents}</span>}
                                                        </Link>
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </>
                                        )}
                                    </Disclosure>
                                </>
                            )}

                            {current_staff?.hideResidents != 1 &&
                                (window.location.hostname === "apply.qliving.co.za" || window.location.hostname === "wh-romi-staging.whitehart.co.za" || window.location.hostname === "localhost") && (
                                    <>
                                        <Disclosure as="div" className="space-y-1">
                                            {({ open }) => (
                                                <>
                                                    <Disclosure.Button className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none">
                                                        <svg
                                                            className={classNames(
                                                                open ? "rotate-90" : "",
                                                                "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                                            )}
                                                            viewBox="0 0 20 20"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                                        </svg>
                                                        <span className="flex-1 font-light text-xs pr-4">VACATING</span>
                                                        {current_staff?.restrict_views === 0 ? <span className="ml-3 inline-block px-3 text-xs">{totalVacatingCount}</span> : ""}
                                                    </Disclosure.Button>
                                                    <Transition
                                                        enter="transition duration-100 ease-out"
                                                        enterFrom="transform scale-95 opacity-0"
                                                        enterTo="transform scale-100 opacity-100"
                                                        leave="transition duration-75 ease-out"
                                                        leaveFrom="transform scale-100 opacity-100"
                                                        leaveTo="transform scale-95 opacity-0"
                                                    >
                                                        <Disclosure.Panel>
                                                            {current_staff?.restrict_views === 0 ? (
                                                                <Link
                                                                    key="All Vacating"
                                                                    to="/booking/vacating"
                                                                    className={classNames(
                                                                        location.pathname === "/booking/vacating" && !tag_id ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                                        "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background ",
                                                                    )}
                                                                >
                                                                    <span className="flex-1 font-light">All Vacating</span>
                                                                    {allVacatingRed ? (
                                                                        <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{allVacatingRed} | &nbsp; </span>
                                                                    ) : null}
                                                                    {allVacatingOrange > 0 ? <span className="inline-block py-1 text-xs text-yellow-400">{allVacatingOrange} | &nbsp; </span> : null}
                                                                    {allVacating ? <span className="inline-block py-1 text-xs text-green-400 font-medium">{allVacating}</span> : null}
                                                                </Link>
                                                            ) : (
                                                                ""
                                                            )}

                                                            {vacatingTagsList?.length > 0 &&
                                                                vacatingTagsList.map((tag) => (
                                                                    <React.Fragment key={`vacating_tag_${tag.id}`}>
                                                                        {current_staff?.restrict_views === 0 || (current_staff?.restrict_views === 1 && tag.id === 21) ? (
                                                                            tag.super_only == 0 ||
                                                                            (tag.super_only == 1 &&
                                                                                (current_staff.email == "roger@whitehart.co.za" ||
                                                                                    current_staff.email == "rowan@qholdings.co.za" ||
                                                                                    current_staff.email == "resileads@qholdings.co.za")) ? (
                                                                                <Link
                                                                                    to={"/booking/vacating?tag=" + tag.id}
                                                                                    key={"vacating_tag_" + tag.id}
                                                                                    className={classNames(
                                                                                        parseInt(tag_id) === tag.id ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                                                        "group flex rounded-l-3xl items-center pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                                                    )}
                                                                                >
                                                                                    <span className="flex-1 font-light">{tag.name}</span>
                                                                                    {tag.red ? (
                                                                                        <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{tag.red} | &nbsp; </span>
                                                                                    ) : null}
                                                                                    {tag.countOrange && tag.countOrange > 0 ? (
                                                                                        <span className="inline-block py-1 text-xs text-yellow-400">{tag.countOrange} | &nbsp; </span>
                                                                                    ) : null}
                                                                                    {tag.count ? <span className="inline-block py-1 text-xs text-green-400 font-medium">{tag.count}</span> : null}
                                                                                </Link>
                                                                            ) : (
                                                                                ""
                                                                            )
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </React.Fragment>
                                                                ))}

                                                            <Link
                                                                to="/booking/vacating?tag=orphaned"
                                                                className={classNames(
                                                                    location.pathname === "/booking/vacating?tag=orphaned" ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                                    "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                                )}
                                                            >
                                                                <span className="flex-1 font-light">Unlinked</span>
                                                                {orphanedRedVacating > 0 && <span className="ml-3 inline-block py-1 text-xs text-red-400">{orphanedRedVacating} | &nbsp; </span>}
                                                                {orphanedVacating > 0 && <span className="inline-block py-1 text-xs text-green-400">{orphanedVacating}</span>}
                                                            </Link>
                                                        </Disclosure.Panel>
                                                    </Transition>
                                                </>
                                            )}
                                        </Disclosure>
                                    </>
                                )}

                            {process.env.REACT_APP_COLOUR === "UC" && (!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") && (
                                <>
                                    {current_staff?.restrict_views === 0 ? (
                                        <Disclosure as="div" className="space-y-1">
                                            {({ open }) => (
                                                <>
                                                    <Disclosure.Button className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none">
                                                        <svg
                                                            className={classNames(
                                                                open ? "rotate-90" : "",
                                                                "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                                            )}
                                                            viewBox="0 0 20 20"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                                        </svg>
                                                        <span className="flex-1 font-light text-xs pr-4">COLLECTIONS</span>
                                                        <span className="ml-3 inline-block px-3 text-xs">{totalCollections}</span>
                                                    </Disclosure.Button>
                                                    <Transition
                                                        enter="transition duration-100 ease-out"
                                                        enterFrom="transform scale-95 opacity-0"
                                                        enterTo="transform scale-100 opacity-100"
                                                        leave="transition duration-75 ease-out"
                                                        leaveFrom="transform scale-100 opacity-100"
                                                        leaveTo="transform scale-95 opacity-0"
                                                    >
                                                        <Disclosure.Panel>
                                                            <Link
                                                                key="All Residents"
                                                                to="/booking/collections?collection_tag=-1"
                                                                className={classNames(
                                                                    location.pathname === "/booking/residents" ? "bg-white text-dark_background" : "hover:bg-white  text-white",
                                                                    "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background ",
                                                                )}
                                                            >
                                                                <span className="flex-1 font-light">All</span>
                                                            </Link>

                                                            {collectionsList?.length > 0 &&
                                                                collectionsList.map((collection) => (
                                                                    <Link
                                                                        to={"/booking/collections?collection_tag=" + collection.id}
                                                                        key={"collection_" + collection.id}
                                                                        className={classNames(
                                                                            parseInt(collection_tag) === collection.id ? "bg-white  text-dark_background" : "hover:bg-white text-white",
                                                                            "group flex rounded-l-3xl items-center pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                                        )}
                                                                    >
                                                                        <span className="flex-1 font-light">{collection.name}</span>
                                                                        {collection.id !== 8 ? (
                                                                            <>
                                                                                {collection.red ? (
                                                                                    <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{collection.red} | &nbsp; </span>
                                                                                ) : null}
                                                                                {collection.count ? (
                                                                                    <span className="inline-block py-1 text-xs text-green-400 font-medium">{collection.count}</span>
                                                                                ) : null}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {collection.redEx ? (
                                                                                    <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{collection.redEx} | &nbsp; </span>
                                                                                ) : null}
                                                                                {collection.ex ? <span className="inline-block py-1 text-xs text-green-400 font-medium">{collection.ex}</span> : null}
                                                                            </>
                                                                        )}
                                                                    </Link>
                                                                ))}
                                                        </Disclosure.Panel>
                                                    </Transition>
                                                </>
                                            )}
                                        </Disclosure>
                                    ) : (
                                        ""
                                    )}
                                </>
                            )}

                            {settings && settings.brokers === 1 ? (
                                <>
                                    <Disclosure as="div" className="space-y-1">
                                        {({ open }) => (
                                            <>
                                                <Disclosure.Button className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none">
                                                    <svg
                                                        className={classNames(
                                                            open ? "rotate-90" : "",
                                                            "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                                        )}
                                                        viewBox="0 0 20 20"
                                                        aria-hidden="true"
                                                    >
                                                        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                                    </svg>
                                                    <span className="flex-1 font-light text-xs pr-4">BROKERS</span>
                                                    <span className="ml-3 inline-block px-3 text-xs">{totalBrokers}</span>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel>
                                                        <Link
                                                            key="All Residents"
                                                            to="/booking/brokers"
                                                            className={classNames(
                                                                location.pathname === "/booking/brokers" ? "bg-white text-dark_background" : "hover:bg-white  text-white",
                                                                "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background ",
                                                            )}
                                                        >
                                                            <span className="flex-1 font-light">All</span>
                                                            {totalBrokersRed && totalBrokersRed > 0 ? (
                                                                <span className="ml-3 inline-block py-1 pl-3 text-red-400 text-xs">{totalBrokersRed} | &nbsp; </span>
                                                            ) : null}
                                                            {totalBrokers ? <span className="inline-block py-1 text-xs text-green-400">{totalBrokers} &nbsp; </span> : null}
                                                        </Link>
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </>
                                        )}
                                    </Disclosure>
                                </>
                            ) : (
                                ""
                            )}

                            {process.env.REACT_APP_COLOUR === "UC" && (
                                <Disclosure as="div" className="space-y-1">
                                    {({ open }) => (
                                        <>
                                            <Disclosure.Button className="text-divider border-b-2 border-gray-400 text-sm group w-full flex items-center pr-2 py-2 text-left focus:outline-none">
                                                <svg
                                                    className={classNames(
                                                        open ? "rotate-90" : "",
                                                        "text-divider mr-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150",
                                                    )}
                                                    viewBox="0 0 20 20"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                                                </svg>
                                                <span className="flex-1 font-light text-xs pr-4">GENERAL</span>
                                                {current_staff?.restrict_views === 0 ? <span className="ml-3 inline-block px-3 text-xs">{totalGeneralCount}</span> : ""}
                                            </Disclosure.Button>
                                            <Transition
                                                enter="transition duration-100 ease-out"
                                                enterFrom="transform scale-95 opacity-0"
                                                enterTo="transform scale-100 opacity-100"
                                                leave="transition duration-75 ease-out"
                                                leaveFrom="transform scale-100 opacity-100"
                                                leaveTo="transform scale-95 opacity-0"
                                            >
                                                <Disclosure.Panel>
                                                    {tagsList23?.length > 0 &&
                                                        tagsList23.map((tag) => (
                                                            <React.Fragment key={`tag2_${tag.id}`}>
                                                                {current_staff?.restrict_views === 0 || (current_staff?.restrict_views === 1 && tag.id === 21) ? (
                                                                    <Link
                                                                        to={"/booking/general?tag=" + tag.id}
                                                                        key={"tag2_" + tag.id}
                                                                        className={classNames(
                                                                            parseInt(tag_id) === tag.id ? "bg-white  text-dark_background" : "hover:bg-white text-white",
                                                                            "group flex rounded-l-3xl items-center pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                                        )}
                                                                    >
                                                                        <span className="flex-1 font-light">{tag.name}</span>
                                                                        {tag.red ? <span className="ml-3 inline-block py-1 text-xs text-red-400 font-medium">{tag.red} | &nbsp; </span> : null}
                                                                        {tag.countOrange && tag.countOrange > 0 ? (
                                                                            <span className="inline-block py-1 text-xs text-yellow-400">{tag.countOrange} | &nbsp; </span>
                                                                        ) : null}
                                                                        {tag.count ? <span className="inline-block py-1 text-xs text-green-400 font-medium">{tag.count}</span> : null}
                                                                    </Link>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </React.Fragment>
                                                        ))}

                                                    <Link
                                                        to="/booking/general?tag=orphaned"
                                                        className={classNames(
                                                            location.pathname === "/booking/general?tag=orphaned" ? "bg-white text-dark_background" : "hover:bg-white text-white",
                                                            "group flex items-center rounded-l-3xl pl-4 pr-3 py-2 text-sm font-medium transition ease-linear delay-50 hover:text-dark_background",
                                                        )}
                                                    >
                                                        <span className="flex-1 font-light">Unlinked</span>
                                                        {orphanedRedGeneral > 0 && <span className="ml-3 inline-block py-1 text-xs text-red-400">{orphanedRedGeneral} | &nbsp; </span>}
                                                        {orphanedGeneral > 0 && <span className="inline-block py-1 text-xs text-green-400">{orphanedGeneral}</span>}
                                                    </Link>
                                                </Disclosure.Panel>
                                            </Transition>
                                        </>
                                    )}
                                </Disclosure>
                            )}

                            {/* Archived Section */}
                            <ArchivedSection />

                            {staff && staff.length > 0 && (
                                <>
                                    <div className="py-4">
                                        <p className="font-light text-divider border-gray-400 border-b-2 pb-2 text-xs">ONLINE</p>
                                        <div className="py-2 flex space-x-2 flex-wrap">
                                            <StaffOnline type="online" staff={staff} styling="-mr-6" />
                                        </div>
                                    </div>
                                </>
                            )}

                            {current_staff?.hideSettings != 1 && (
                                <>
                                    {!current_staff?.building_manager && !current_staff?.is_plumber && !current_staff?.is_electrician ? (
                                        <button
                                            onClick={() =>
                                                dispatch(
                                                    openModal({
                                                        modal_type: "ModalCreateApplication",
                                                    }),
                                                )
                                            }
                                            type="button"
                                            className="hover:bg-white hover:rounded-3xl text-white group flex items-center pr-3 py-2 text-sm font-medium hover:text-dark_background"
                                        >
                                            <FontAwesomeIcon className="mr-3 w-6 flex-shrink-0 text-primary" aria-hidden="true" icon={faMessagePlus} />
                                            <span className="flex-1 font-light">Create a Chat</span>
                                        </button>
                                    ) : (
                                        ""
                                    )}
                                    {settings_navigation.map((item) => (
                                        <Link
                                            key={"setnav_" + item.name}
                                            to={item.href}
                                            className={classNames(
                                                location.pathname === item.href ? "bg-white rounded-l-3xl text-dark_background" : "hover:bg-white hover:rounded-l-3xl text-white",
                                                "group flex items-center pr-3 py-2 text-sm font-medium hover:text-dark_background",
                                            )}
                                        >
                                            <FontAwesomeIcon className="mr-3 w-6 flex-shrink-0 text-primary" aria-hidden="true" icon={item.icon} />
                                            <span className="flex-1 font-light">{item.name}</span>
                                        </Link>
                                    ))}
                                    <a
                                        className={classNames("hover:bg-white hover:rounded-l-3xl text-white", "group flex items-center pr-3 py-2 text-sm font-medium hover:text-dark_background")}
                                        href="https://forms.clickup.com/9012594561/f/8ck2hw1-1412/ZXA7LJUYVDE7HBDMS3"
                                        target="_blank"
                                    >
                                        <FontAwesomeIcon className="mr-3 w-6 flex-shrink-0 text-primary" aria-hidden="true" icon={faBug} />
                                        <span className="flex-1 font-light">Log a Bug</span>
                                    </a>
                                </>
                            )}
                        </nav>
                    </div>
                    <div className="pt-6 pb-2 border-b-2 border-gray-400" />
                    <div className="flex-shrink-0 flex py-4">
                        <a href="#" className="flex-shrink-0 w-full group block">
                            <div className="flex items-center">
                                <ProfilePicture id={current_staff?.id} />
                                <div className="ml-1">
                                    <p className="text-sm text-divider font-light uppercase">
                                        {current_staff?.name + " " + current_staff?.surname} {current_staff?.status === "Admin" && " (" + current_staff?.status + ")"}
                                    </p>
                                    <button className="text-xs  text-divider font-light group-hover:text-gray-200 uppercase" onClick={() => signout()}>
                                        Sign Out
                                    </button>

                                    <p className="text-sm text-divider font-light uppercase">V {FRONTEND_VERSION}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="md:pl-64 flex flex-col flex-1">
                <div className="sticky top-0 z-10 md:hidden px-4 pt-4 sm:pl-3 sm:pt-3 bg-black flex">
                    {process.env.REACT_APP_COLOUR === "UC" ? (
                        <img className="h-12 w-auto mx-auto" src="/images/logo_uc.svg" alt="Urban Circle" />
                    ) : (
                        <>
                            {process.env.REACT_APP_COLOUR === "QL" ? (
                                <img className="h-12 w-auto mx-auto" src="/images/QL_Logo_final_white.png" alt="Quorum Living" />
                            ) : (
                                <img className="h-12 w-auto mx-auto" src="/images/logo-qholdings-v2.png" alt="Quorum Properties" />
                            )}
                        </>
                    )}
                    <button
                        type="button"
                        className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset"
                        onClick={() => setSidebarOpen(true)}
                    >
                        <span className="sr-only">Open sidebar</span>
                        <FontAwesomeIcon className="h-6 w-6 text-white" aria-hidden="true" icon={faBars} />
                    </button>
                </div>
            </div>
        </>
    );
}
